module.exports = __webpack_public_path__ + "media/buddha-kontekst-no-copyright-music.ef2f6821.mp3";